import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import VideoCover from 'react-video-cover';
import LazyLoad from 'react-lazyload';

import withDeviceType from '../../../hoc/withDeviceType';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import Picture from './Picture';

class Video extends Component {
  render() {
    const { src, autoPlay, loop, videoThumb, isMobile } = this.props;
    const video = (
      <VideoCover
        videoOptions={{
          src,
          autoPlay,
          loop,
          muted: autoPlay,
          playsInline: autoPlay,
          preload: 'true'
        }}
        style={{
          backgroundImage: 'none',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      />
    );
    return (
      <Fragment>
        {typeof window !== 'undefined' && (
          <Fragment>
            {!isMobile && videoThumb && (
              <LazyLoad
                offset={200}
                placeholder={<Picture largeImage={videoThumb} fullBleed />}
                once
              >
                {video}
              </LazyLoad>
            )}
            {!isMobile && !videoThumb && video}
            {isMobile && <Picture largeImage={videoThumb} fullBleed />}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

Video.propTypes = {
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  src: PropTypes.string,
  videoThumb: PropTypes.string
};

export default compose(
  DisplayComponent,
  withDeviceType
)(Video);
